import React from "react";
import { Menu, MenuItem, Checkbox, ListItemText } from "@mui/material";

// Menu "Kolumny": włączanie i wyłączanie widoczności kolumn tabeli.
const ColumnsMenu = ({ anchorEl, onClose, columns, hiddenColumns, onToggle, onReset }) => (
  <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onClose}>
    {columns.map((column) => (
      <MenuItem key={column.id} dense onClick={() => onToggle(column.id)}>
        <Checkbox
          size="small"
          edge="start"
          checked={!hiddenColumns.includes(column.id)}
          tabIndex={-1}
          disableRipple
        />
        <ListItemText primary={column.label} />
      </MenuItem>
    ))}
    <MenuItem dense onClick={onReset}>
      <ListItemText
        primary="Przywróć domyślne"
        primaryTypographyProps={{ color: "primary" }}
      />
    </MenuItem>
  </Menu>
);

export default ColumnsMenu;
